import { render, staticRenderFns } from "./Startups.vue?vue&type=template&id=ab55e634"
import script from "./Startups.vue?vue&type=script&lang=js"
export * from "./Startups.vue?vue&type=script&lang=js"
import style0 from "./Startups.vue?vue&type=style&index=0&id=ab55e634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports